import { Build, Inventory } from '@mui/icons-material';
import { BottomNavigationAction } from '@mui/material';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { StyledBottomNavigation } from './MobileBottomNav.styles';

export const MobileBottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentValue = () => {
    if (location.pathname.includes('/mobile/services')) {
      return 'services';
    }
    if (location.pathname.includes('/mobile/parts')) {
      return 'parts';
    }
    return 'services';
  };

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    switch (newValue) {
      case 'services':
        navigate('/mobile/services');
        break;
      case 'parts':
        navigate('/parts/search');
        break;
    }
  };

  return (
    <StyledBottomNavigation value={getCurrentValue()} onChange={handleChange} showLabels>
      <BottomNavigationAction label="Services" value="services" icon={<Build />} />
      <BottomNavigationAction label="Parts" value="parts" icon={<Inventory />} />
    </StyledBottomNavigation>
  );
};
